import type { PlanId } from "./tariff";
import type { SupportRequestInfo } from "./admin";

/** Antwortformate der HandVero-API, gemeinsam für Server, Website und Apps. */

export type Role = "owner" | "admin" | "employee";

export const ROLE_LABELS: Record<Role, string> = {
  owner: "Inhaber",
  admin: "Admin",
  employee: "Mitarbeiter",
};

export interface ApiError {
  error: string;
  code?: string;
}

export interface PublicStats {
  founderSlotsTotal: number;
  founderSlotsLeft: number;
  subscriptionBookable: boolean;
  /** Anmeldung für Privatpersonen („Zuhause“) geöffnet. */
  privateSignupOpen: boolean;
}

export interface MeUser {
  id: string;
  name: string;
  email: string;
  role: Role;
}

export interface MeCompany {
  id: string;
  name: string;
  plan: PlanId;
  planLabel: string;
  founderNumber: number | null;
  validUntil: string | null;
  employeeLimit: number;
  /** Windows-Software und Zusatzfunktionen im Paket enthalten (gilt, sobald die Software verfügbar ist). */
  desktopAccess: boolean;
  seatsUsed: number;
  /** Betriebskonto oder Privatkonto („Zuhause“). */
  accountKind: "business" | "private";
  /** Nur bei Privatkonten: Speicherverbrauch und Grenze. */
  storage: { usedBytes: number; limitBytes: number; plan: "free" | "plus" } | null;
}

export interface TeamMember {
  id: string;
  name: string;
  email: string;
  role: Role;
}

export interface PendingInvitation {
  id: string;
  email: string;
  expiresAt: string;
}

export interface MeResponse {
  user: MeUser;
  company: MeCompany;
  members: TeamMember[];
  invitations: PendingInvitation[];
  subscriptionBookable: boolean;
  /** Gebuchte Zusatzfunktionen der Firma (Zusatzabos). */
  addons: { plans: boolean; billing: boolean };
  /** Darf den Super-Admin-Bereich öffnen. */
  superAdmin: boolean;
  /** Nur für Super-Admins auf der freigegebenen Version: Adresse der Vorschau mit neuen Funktionen. */
  previewUrl: string | null;
  /** Nur in der Vorschau: Adresse der freigegebenen Version, für den Weg zurück. */
  liveUrl: string | null;
  /** Gesetzt, wenn gerade der HandVero-Support in diesem Konto arbeitet. */
  support: { expiresAt: string } | null;
  /** Anfragen des Supports an diese Firma (nur für Inhaber und Admins). */
  supportRequests: SupportRequestInfo[];
}

export interface InvitationPreview {
  companyName: string;
  email: string;
}

/** Ein Gerät oder Browser, in dem die Person angemeldet ist. */
export interface SessionInfo {
  id: string;
  device: string;
  createdAt: string;
  lastSeenAt: string;
  current: boolean;
  /** Sitzung des HandVero-Supports mit Freigabe der Firma. */
  support: boolean;
}
